export default {
  data() {
    return {
      selectedRows: [],
    };
  },
  computed: {
    hasSelection() {
      return this.selectedRows.length > 0;
    },
    selectionCount() {
      return this.selectedRows.length;
    },
    selectableRows() {
      const rows = Array.isArray(this.drafts) ? this.drafts : [];
      return rows.filter((row) => this.isRowSelectableForBulk(row));
    },
    isAllSelected() {
      const selectable = this.selectableRows;
      if (!selectable.length) return false;
      const selectedIds = new Set(this.selectedRows.map((r) => r?.id).filter((id) => id != null));
      return selectable.every((r) => selectedIds.has(r.id));
    },
    isIndeterminate() {
      const selectable = this.selectableRows;
      if (!selectable.length) return false;
      const selectedIds = new Set(this.selectedRows.map((r) => r?.id).filter((id) => id != null));
      const any = selectable.some((r) => selectedIds.has(r.id));
      return any && !this.isAllSelected;
    },
    draftCountInSelectionForDelete() {
      return this.selectedRows.filter((r) => r?.actions?.canDelete).length;
    },
  },
  watch: {
    drafts: {
      deep: true,
      handler(newDrafts) {
        const list = Array.isArray(newDrafts) ? newDrafts : [];
        this.selectedRows = this.selectedRows
          .map((sel) => list.find((d) => d && sel && d.id === sel.id))
          .filter(Boolean);
      },
    },
  },
  methods: {
    getRowSelectionKey(row) {
      return row?.id ?? null;
    },
    isRowSelectableForBulk(row) {
      return Boolean(row?.id && row?.actions?.canIssue);
    },
    clearSelection() {
      this.selectedRows = [];
      if (typeof this.$refs.draftTable?.clearSelected === 'function') {
        this.$refs.draftTable.clearSelected();
      }
    },
    toggleSelectAll() {
      if (this.isAllSelected) {
        this.selectedRows = [];
      } else {
        this.selectedRows = [...this.selectableRows];
      }
    },
  },
};
